module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/mobileCup-b938401e0220c6f161a4130ff8e671f8.png";